import { render, staticRenderFns } from "./DeleteOrderFee.vue?vue&type=template&id=76c6df27&scoped=true"
import script from "./DeleteOrderFee.vue?vue&type=script&lang=js"
export * from "./DeleteOrderFee.vue?vue&type=script&lang=js"
import style0 from "./DeleteOrderFee.vue?vue&type=style&index=0&id=76c6df27&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c6df27",
  null
  
)

export default component.exports